const actions = {
  SET_STATE: 'locales/SET_STATE',
}

export default actions
